import { SectionContainer } from "@/components/SectionContainer/SectionContainer";
import { Box, Button, Menu, MenuItem, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useRef } from "react";
import { Calendario } from "@/components/calendarComponent";
import { RegisterLead } from "@/interfaces/RegisterLead";
import { etapaJornadaOptions, useLeads} from "@/pages/leads/context/leadContext";
import { delay } from "@/utils/delay";
import { leadApi } from "@/services/api/leads";
import { CustomSnackbar } from "@/utils/alert";
import { CreateLeadModal } from "@/pages/leads/ModalLeadCreate";
import style from "./kanbanSearch.module.css";
import GroupsIcon from "@mui/icons-material/Groups";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import attendantApi from "@/services/api/attendant";
import AddIcon from "@mui/icons-material/Add";
import attendantStorage from "@/utils/LocalStorage/attendant";
import Chip from "@mui/material/Chip";
import { capitalizeWords } from "@/utils/capitalizeWords";
import { Archive } from "@mui/icons-material";
import { useKanbanSearch } from "../kanbanSearchContext/KanbanSearchContext";
interface Attendant {
  id: string;
  nome: string;
}

type Severity = "success" | "error";

const useDebounce = (callback: Function, delay: number) => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const debouncedFunction = (...args: any[]) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };

  return debouncedFunction;
};

interface KanbanSearchBarPageProps {
  
  selectedOptionOrigin: string[]; // Alterado para array de strings
  setSelectedOptionOrigin: React.Dispatch<React.SetStateAction<string[]>>; // Alterado para aceitar array
  selectedOptionJourneyStage: string[]; // Alterado para array de strings
  setSelectedOptionJourneyStage: React.Dispatch<React.SetStateAction<string[]>>; // Alterado para aceitar array
  reload: boolean;
  setReload: React.Dispatch<React.SetStateAction<boolean>>;
  startDate: Date | null; // Adicione isso
  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>; // Adicione isso
  endDate: Date | null; // Adicione isso
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>; // Adicione isso
  onFilterRemove?: (filter: string) => void; // Adicione esta linha
}

export function KanbanSearchBarPage({
  selectedOptionOrigin,
  setSelectedOptionOrigin,
  selectedOptionJourneyStage,
  setSelectedOptionJourneyStage,
  setStartDate,
  setEndDate,
  onFilterRemove,
  setReload,
  reload
}: KanbanSearchBarPageProps) {
  const [menuAnchorElementCreatedAt, setMenuAnchorElementCreatedAt] =useState<null | HTMLElement>(null);
  const [menuAnchorElementAttendant, setMenuAnchorElementAttendant] =useState<null | HTMLElement>(null);
  const [menuAnchorElementJourneyStage, setMenuAnchorElementJourneyStage] =useState<null | HTMLElement>(null); // Separado para etapas da jornada
  const [menuAnchorElementOrigin, setMenuAnchorElementOrigin] =useState<null | HTMLElement>(null); // Separado para o calendário
  const [attendantOption, setAttendantOption] = useState<Attendant[]>([]);
  const [etapaJornadaOptionsWithAll, setEtapaJornadaOptionsWithAll] = useState<string[]>([]);
  const [originalAttendantOption, setOriginalAttendantOption] = useState<Attendant[]>([]); // Armazene a lista original
  const [listOrigens, setListOrigens] = useState<string[]>([]);
  const [originalListOrigens, setOriginalListOrigens] = useState<string[]>([]); // Armazena a lista original
  const [originalStageOption, setOriginalStageOption] = useState<string[]>([]); // Armazena a lista original
  const [removedFilter, setRemovedFilter] = useState<string | null>(null);
  const { fetchLeads, loading, addLeadCreated, setFilterArchived, filterArchived } = useLeads();
  const openCreatedAt = Boolean(menuAnchorElementCreatedAt);
  const [activeFilters, setActiveFilters] = useState<string[]>([]);
  const [showAlert, setShowAlert] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertInfo, setAlertInfo] = useState({
    severity: "success" as Severity,
    message: "",
  });

  const createAtOptions = [
    { label: "Hoje", value: "Hoje" },
    { label: "Esta semana", value: "Esta semana" },
    { label: "Este mês", value: "Este mês" },
  ];

  const {selectedOptionCreatedAt, selectedOptionAttendant, searchTerm, setSelectedOptionCreatedAt, setSelectedOptionAttendant, setSearchTerm} = useKanbanSearch();
  const kanbanSearchContext = useKanbanSearch();

  useEffect(() => {
    const fetchAttendants = async () => {
      try {
        const response = await attendantApi.getAttendants();
        const origens = await leadApi.getListOrigens();
        setEtapaJornadaOptionsWithAll( [...etapaJornadaOptions,
          "Todas as etapas"])
        setOriginalStageOption(etapaJornadaOptionsWithAll); // Aqui estou armazenando a lista original
        setListOrigens([...origens.data, "Todas as opções",]);
        setOriginalListOrigens([...origens.data, "Todas as opções"]); // Armazene a lista original
        const attendants = response.data.map((attendant: any) => ({
          id: attendant.id,
          nome: attendant.nome,
        }));
        setAttendantOption([...attendants,
          { id: "all", nome: "Todos os atendentes" }
        ]);
        setOriginalAttendantOption([...attendants,
          { id: "all", nome: "Todos os atendentes" }
        ]); // Armazene a lista original
      } catch (error) {
        console.error("Erro ao buscar atendentes:", error);
      }
    };

    fetchAttendants();
  }, []); 

  const handleMenuOpenCreatedAt = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorElementCreatedAt(event.currentTarget);
  };

  const handleMenuCloseCreatedAt = () => {
    setMenuAnchorElementCreatedAt(null);
  };

  const handleSelectJourneyStage = (option: string) => {
    if (option === "Todas as etapas") {
        setSelectedOptionJourneyStage([]); // Limpa os filtros
        setActiveFilters(prevFilters => 
            prevFilters.filter(filter => 
                !etapaJornadaOptions.includes(filter)
            ) // Remove todos os chips de etapas da jornada
        );
    } else {
        const alreadySelected = selectedOptionJourneyStage.includes(option);
        let newSelectedStages: string[];

        if (alreadySelected) {
            // Se já estiver selecionado, removemos do array
            newSelectedStages = selectedOptionJourneyStage.filter(
                (stage) => stage !== option
            );
            // Remove o filtro do chip
            setActiveFilters(prevFilters => prevFilters.filter(filter => filter !== option));
        } else {
            // Se não estiver selecionado, adicionamos ao array
            newSelectedStages = [...selectedOptionJourneyStage, option];
            addFilter(option); // Adiciona ao chip
        }

        setSelectedOptionJourneyStage(newSelectedStages);
    }
  };

  const handleMenuOpenJourneyStage = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorElementJourneyStage(event.currentTarget); // Menu de etapas da jornada
  };

  const handleMenuCloseJourneyStage = () => {
    setMenuAnchorElementJourneyStage(null);
  };

  const handleMenuOpenAttendant = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorElementAttendant(event.currentTarget);
  };

  const handleMenuCloseAttendant = () => {
    setMenuAnchorElementAttendant(null);
  };

  const handleMenuOpenOrigin = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorElementOrigin(event.currentTarget); // Usando o estado separado para o calendário
  };

  const handleMenuCloseOrigin = () => {
    setMenuAnchorElementOrigin(null); // Fechar menu de origem (calendário)
  };

  const handleSelectAttendant = (attendant: Attendant) => {
    if (attendant.nome === "Todos os atendentes") {
        // Limpa todos os filtros de atendente e os chips relacionados
        setSelectedOptionAttendant([]);
        setActiveFilters(prevFilters =>
            prevFilters.filter(filter =>
                !originalAttendantOption.some(att => att.nome === filter)
            )
        );
    } else {
        const isAlreadySelected = selectedOptionAttendant?.includes(attendant.id);
        let newSelectedAttendants: string[];

        if (isAlreadySelected) {
            // Se já estiver selecionado, removemos da lista de selecionados e do chip
            newSelectedAttendants = selectedOptionAttendant?.filter(
                (selectedAttendantId) => selectedAttendantId !== attendant.id
            ) ?? [];
            setActiveFilters(prevFilters => prevFilters.filter(filter => filter !== attendant.nome));
        } else {
            // Caso contrário, adicionamos ao array de selecionados e ao chip apenas se não estiver presente
            newSelectedAttendants = [...selectedOptionAttendant ?? [], attendant.id];
            if (!activeFilters.includes(attendant.nome)) {
                addFilter(attendant.nome); // Adiciona ao chip sem duplicar
            }
        }

        setSelectedOptionAttendant(newSelectedAttendants);
    }

    // Fecha o menu após a seleção
    setMenuAnchorElementAttendant(null);
  };



  const handlerSelectOrigin = (origem: string) => {
    if (origem === "Todas as opções") {
        setSelectedOptionOrigin([]); // Limpa todos os filtros de origem
        setActiveFilters(prevFilters =>
            prevFilters.filter(filter =>
                !originalListOrigens.includes(filter)
            ) // Remove todos os chips de origem
        );
    } else {
        const alreadySelected = selectedOptionOrigin.includes(origem);
        let newSelectedOrigins: string[];

        if (alreadySelected) {
            // Se já estiver selecionado, removemos do array de seleção
            newSelectedOrigins = selectedOptionOrigin.filter(
                (origin) => origin !== origem
            );
            // Remove o filtro do chip
            setActiveFilters(prevFilters => prevFilters.filter(filter => filter !== origem));
        } else {
            // Se não estiver selecionado, adicionamos ao array de seleção e ao chip
            newSelectedOrigins = [...selectedOptionOrigin, origem];
            addFilter(origem); // Adiciona ao chip
        }

        setSelectedOptionOrigin(newSelectedOrigins);
    }
    setMenuAnchorElementOrigin(null);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if(event.target.value.trim().length === 0) {
      setRemovedFilter("Busca");
      setSearchTerm("");
      return;
    }
    setSearchTerm(event.target.value.trim().length == 0 ? "" : event.target.value);
    console.log("searchTerm", event.target.value.trim());
    console.log("length", event.target.value.trim().length);
  };

  const handleDateChange = (newStartDate: Date, newEndDate: Date) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setMenuAnchorElementCreatedAt(null); // Fechar o menu após a confirmação
  };

  const handleCancelDateSelection = () => {
    setStartDate(null);
    setEndDate(null);
    setMenuAnchorElementCreatedAt(null); // Fechar o menu após o cancelamento
  };

  function handleAlertClose() {
    setShowAlert(false);
  }

  async function handleSaveLead(leadData: RegisterLead) {
    const attendant = attendantStorage.getToken();
    if (attendant) {
      leadData.attendantId = attendant.id;
      try {
        const response = await leadApi.create(leadData);
        if (response.status === 201) {
          addLeadCreated(response.data.response);
          setAlertInfo({
            severity: "success",
            message: "Lead criado com sucesso",
          });
          setShowAlert(true);
          await delay(1500);
          fetchLeads(); // Atualiza os leads na tabela após a criação
          setOpen(false);
        }
      } catch (error) {
        console.error("Erro ao criar lead:", error);
        setAlertInfo({
          severity: "error",
          message: "Erro ao criar lead",
        });
        setShowAlert(true);
      }
    }
  }

  const addFilter = (newFilter: string) => {
    if (!activeFilters.includes(newFilter)) {
      setActiveFilters([...activeFilters, newFilter]);
    }
  };  

  const debouncedRemoveFilter = useDebounce((filterToRemove: string) => {
    // Atualiza a lista de filtros ativos, removendo o filtro especificado
    setActiveFilters((prevFilters) =>
      // Filtra a lista de filtros ativos, excluindo o filtro que deve ser removido
      prevFilters.filter((f) => f !== filterToRemove)
    );

    // Se remover o filtro de "Criado em", resetar o valor correspondente
    if (filterToRemove === selectedOptionCreatedAt) {
      setSelectedOptionCreatedAt(null);
    }

    // Se remover o filtro de atendente, remover da lista de atendentes selecionados
    const attendantToRemove = attendantOption.find(
      (attendant) => attendant.nome === filterToRemove
    );
    if (attendantToRemove) {
      setSelectedOptionAttendant((prev) =>
        prev ? prev.filter((attendant) => attendant !== attendantToRemove.id) : []
      );
    }
  }, 500);

  const handleRemoveFilter = (filter: string) => {
    setActiveFilters(prevFilters => prevFilters.filter(f => f !== filter));

    // Se o filtro for de "Atendente"
    const attendantToRemove = originalAttendantOption.find(attendant => attendant.nome === filter);
    if (attendantToRemove) {
      setSelectedOptionAttendant(prev => prev ? prev.filter(id => id !== attendantToRemove.id) : []);
    }
    // Se o filtro for de "Origem"
    if (selectedOptionOrigin.includes(filter)) {
      setSelectedOptionOrigin(selectedOptionOrigin.filter(origin => origin !== filter));
    }
    // Se o filtro for de "Etapa da Jornada"
    if (selectedOptionJourneyStage.includes(filter)) {
      setSelectedOptionJourneyStage(selectedOptionJourneyStage.filter(stage => stage !== filter));
    }

    if(selectedOptionCreatedAt?.includes(filter)) {
      setSelectedOptionCreatedAt(null);
    }
    
    if (onFilterRemove) {
      onFilterRemove(filter);
    }
  };
  

  return (
    <SectionContainer noMargin={true} className={style.sectionContainer}>
      <CustomSnackbar
        open={showAlert}
        severity={alertInfo.severity}
        message={alertInfo.message}
        handleClose={handleAlertClose}
      />
      <CreateLeadModal
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSaveLead}
        loading={loading}
      />
      <Box className={style.headerBody}>
        <Box className={style.creatAtRight}>
          <Button
            className={style.customButton}
            startIcon={<AccessTimeIcon />}
            endIcon={<ArrowDropDownIcon />}
            onClick={handleMenuOpenCreatedAt}
          >
            Criado em
          </Button>
          <Menu
            anchorEl={menuAnchorElementCreatedAt}
            open={Boolean(menuAnchorElementCreatedAt)}
            onClose={handleMenuCloseCreatedAt}
            className={style.menuCreatedAt}
          >
            <Box className={style.menuContent}>
              {/* Caixa das opções em coluna */}
              <Box className={style.optionsContainer}>
                {createAtOptions.map((item: any) => (
                  <MenuItem
                    key={item.value}
                    onClick={() => {
                      setSelectedOptionCreatedAt(item.value);
                      addFilter(item.label);
                      setMenuAnchorElementCreatedAt(null);
                    }}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Box>

              {/* Caixa do calendário */}
              <Box className={style.calendarContainer}>
                <Calendario
                  onDateChange={handleDateChange}
                  onCancel={handleCancelDateSelection} // Passando a função de cancelamento
                />
              </Box>
            </Box>
          </Menu>
          <Menu
            anchorEl={menuAnchorElementCreatedAt}
            open={Boolean(menuAnchorElementCreatedAt)}
            onClose={handleMenuCloseCreatedAt}
            className={style.menuCreatedAt}
          >
            <Box className={style.menuContent}>
              {/* Caixa das opções em coluna */}
              <Box className={style.optionsContainer}>
                {createAtOptions.map((item: any) => (
                  <MenuItem
                    key={item.value}
                    onClick={() => {
                      setSelectedOptionCreatedAt(item.value);
                      addFilter(item.label);
                      setMenuAnchorElementCreatedAt(null);
                    }}
                  >
                    {capitalizeWords(item.label)}
                  </MenuItem>
                ))}
              </Box>

              {/* Caixa do calendário */}
              <Box className={style.calendarContainer}>
                <Calendario
                  onDateChange={(start, end) => {
                    setStartDate(start);
                    setEndDate(end);
                    kanbanSearchContext.setStartDate(start.toISOString());
                    kanbanSearchContext.setEndDate(end.toISOString());
                  }}
                  onCancel={() => {
                    setStartDate(null);
                    setEndDate(null);
                  }}
                />
              </Box>
            </Box>
          </Menu>
        </Box>

        <Box>
          <Button
            className={style.customButton}
            startIcon={<PersonIcon />}
            endIcon={<ArrowDropDownIcon />}
            onClick={handleMenuOpenAttendant}
          >
            Atendente
          </Button>
          <Menu
            anchorEl={menuAnchorElementAttendant}
            open={Boolean(menuAnchorElementAttendant)}
            onClose={handleMenuCloseAttendant}
          >
              {attendantOption.map((option) => (
                <MenuItem 
                  key={option.id}
                  value={option.id}
                  onClick={() => handleSelectAttendant(option)}
                  sx={{
                    backgroundColor: selectedOptionAttendant?.includes(option.id) ? "#ccc" : "transparent",
                    "&:hover": {
                      backgroundColor: "#ccc",
                    },
                  }}
                >
                  {capitalizeWords(option.nome)}
                </MenuItem>
              ))}
          </Menu>
        </Box>

        <Box>
          <Button
            className={style.customButton}
            startIcon={<GroupsIcon />}
            endIcon={<ArrowDropDownIcon />}
            onClick={handleMenuOpenJourneyStage}
          >
            Etapa da Jornada
          </Button>
          <Menu
            anchorEl={menuAnchorElementJourneyStage}
            open={Boolean(menuAnchorElementJourneyStage)}
            onClose={handleMenuCloseJourneyStage}
          >
              {etapaJornadaOptionsWithAll.map((option) => (
                <MenuItem 
                  key={option}
                  value={option}
                  onClick={() => handleSelectJourneyStage(option)}
                  sx={{
                    backgroundColor: selectedOptionJourneyStage.includes(option) ? "#ccc" : "transparent",
                    "&:hover": {
                      backgroundColor: "#ccc",
                    },
                  }}
                >
                  {capitalizeWords(option)}
                </MenuItem>
              ))}
          </Menu>
        </Box>

        <Box>
          <Button
            className={`${style.customButton} ${filterArchived ? style.buttonActive : ""}`}
            startIcon={<Archive />}
            onClick={() => {
              setFilterArchived(!filterArchived)
              setReload(!reload)
            }}
          >

            <span className={style.checkboxLabel}> Mostrar arquivados</span>
          </Button>
        </Box>

        <Box>
          <Button
            className={style.customButton}
            startIcon={<GroupsIcon />}
            endIcon={<ArrowDropDownIcon />}
            onClick={handleMenuOpenOrigin}
          >
            Origem
          </Button>

          <Menu
            anchorEl={menuAnchorElementOrigin}
            open={Boolean(menuAnchorElementOrigin)}
            onClose={handleMenuCloseOrigin}
          >
            {listOrigens.map((origem) => (
              <MenuItem 
                key={origem}
                value={origem}
                onClick={() => handlerSelectOrigin(origem)}
                sx={{
                  backgroundColor: selectedOptionOrigin.includes(origem) ? "#ccc" : "transparent",
                  "&:hover": {
                    backgroundColor: "#ccc",
                  },
                }}
              >
                {capitalizeWords(origem)}
              </MenuItem>
            ))}
          </Menu>
        </Box>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Busca"
          value={searchTerm}
          onInput={handleSearchChange}
          InputProps={{
            startAdornment: <SearchIcon className={style.searchIcon} />,
          }}
          className={style.searchField}
        />

        <Button
          variant="contained"
          disableElevation
          className={style.buttonRegisterCliente}
          type="submit"
          onClick={() => setOpen(true)}
        >
          <AddIcon />
          CADASTRO
        </Button>
      </Box>
      <Box
        className={style.activeFiltersContainer}
        style={{
          maxHeight: activeFilters.length > 0 ? "150px" : "0",
          padding: activeFilters.length > 0 ? "8px" : "0",
        }}
      >
        {activeFilters.map((filter) => (
          <Chip
            key={filter}
            label={filter}
            onDelete={() => handleRemoveFilter(filter)}
            className={style.chip}
          />
        ))}
      </Box>
    </SectionContainer>
  );
}
